import React from 'react'
import DetailRow from './common/DetailRow'
import Disclaimer from './Disclaimer'

class Variable extends React.Component {
  render() {
    const {
      loanAmountLabel,
      repaymentWithFrequency,
      interestTypeLabel,
      rateLabel,
      repaymentType,
      repaymentWithYear,
      repaymentTypeLabel,
      overallLoanTermLabel,
      offsetAccountLabel,
      futureRepayment,
    } = this.props

    return(
      <div>
        <DetailRow title='Loan amount' >
          <div>{ loanAmountLabel }</div>
        </DetailRow>

        <DetailRow title='Repayment of' >
          <div>{ repaymentWithFrequency }</div>
        </DetailRow>

        <DetailRow title='Rate' >
          <div>Variable rate of {rateLabel} p.a.</div>
        </DetailRow>

        <DetailRow title='Repayment type' >
          {
            (repaymentType == 'interest_only') ? (
              <div>{ repaymentWithYear }</div>
            ) : (
              <div>{ repaymentTypeLabel }</div>
            )
          }
        </DetailRow>

        <DetailRow title='Overall loan term' >
          <div>{ overallLoanTermLabel }</div>
        </DetailRow>

        <DetailRow title='Offset account' >
          <div>{ offsetAccountLabel }</div>
        </DetailRow>
        {
          (repaymentType == 'interest_only') && (
            <div>
              <br />
              <Disclaimer
                futureRepayment={ futureRepayment }
              />
            </div>

          )
        }
      </div>
    )
  }
}

export default Variable;
